"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const TargetContext_1 = tslib_1.__importDefault(require("./TargetContext"));
/**
 * React component that can be used to consume the TargetContext.
 *
 * @deprecated TargetContext is not needed anymore. Get the values directly instead by
 *
 * ```typescript
 *   import { getApiUrl, getTargetMeta } from "@mne-core/providers/Target";
 *   const apiUrl = getApiUrl();
 *   const { apiUrl, baseUrl, metaInfo, domain, env, ...} = getTargetMeta();
 *```
 *
 */
const TargetConsumer = (props) => (react_1.default.createElement(TargetContext_1.default.Consumer, { ...props }));
exports.default = TargetConsumer;
